import React__default from 'react';
import { TableBatchActions, TableBatchAction } from 'carbon-components-react';
import { IlOverflowMenu } from '../IlOverflowMenu/IlOverflowMenu/index.js';
import { IlOverflowMenuItem } from '../IlOverflowMenu/IlOverflowMenuItem/index.js';
import { IlTooltipTippy } from '../IlTooltipTippy/index.js';
import { IlIcon } from '../IlIcon/index.js';

/* eslint-disable */
function IlDataTableV3Toolbar(props) {
  function _renderItems() {
    if (!props.items) {
      return null;
    }
    var items = props.items;
    if (props.visibleItems) {
      items = props.items.slice(0, props.visibleItems);
    }
    var rendered = [];
    items.forEach(function (item) {
      var actionItem = /*#__PURE__*/React__default.createElement(TableBatchAction, {
        disabled: item === null || item === void 0 ? void 0 : item.disabled,
        onClick: function onClick(ev) {
          return item.onClick(ev, props.gridApi);
        },
        renderIcon: function renderIcon() {
          return null;
        }
      }, item.title);
      var itemToRender = actionItem;
      if (item !== null && item !== void 0 && item.tooltip) {
        itemToRender = /*#__PURE__*/React__default.createElement(IlTooltipTippy, {
          content: item === null || item === void 0 ? void 0 : item.tooltip,
          placement: 'top',
          appendTo: document.querySelector('body')
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "toolbar-action-button-tooltip-wrapper"
        }, actionItem));
      }
      rendered.push(itemToRender);
    });
    if (props.visibleItems && props.items.length > props.visibleItems) {
      rendered.push(/*#__PURE__*/React__default.createElement(IlOverflowMenu, {
        flipped: true,
        renderIcon: function renderIcon() {
          return /*#__PURE__*/React__default.createElement(IlIcon, {
            name: "gs-more2"
          });
        }
      }, props.items.slice(props.visibleItems).map(function (item) {
        var overflowMenuItem = /*#__PURE__*/React__default.createElement(IlOverflowMenuItem, {
          disabled: item === null || item === void 0 ? void 0 : item.disabled,
          itemText: item.title,
          onClick: function onClick(ev) {
            return item.onClick(ev, props.gridApi);
          }
        });
        var itemToRender = overflowMenuItem;
        if (item !== null && item !== void 0 && item.tooltip) {
          itemToRender = /*#__PURE__*/React__default.createElement(IlTooltipTippy, {
            content: item === null || item === void 0 ? void 0 : item.tooltip,
            placement: 'top',
            appendTo: document.querySelector('body')
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "batch-actions-overflow-item-tooltip-wrapper"
          }, overflowMenuItem));
        }
        return itemToRender;
      })));
    }
    return rendered;
  }
  function renderTranslateWithId(id, state) {
    switch (id) {
      case 'carbon.table.batch.cancel':
        return props.cancelButtonText || 'Cancel';
      case 'carbon.table.batch.item.selected':
        return props.setSingleItemSelectedTranslation ? props.setSingleItemSelectedTranslation(state) : "".concat(state === null || state === void 0 ? void 0 : state.totalSelected, " item selected");
      case 'carbon.table.batch.items.selected':
        return props.setMultipleItemsSelectedTranslation ? props.setMultipleItemsSelectedTranslation(state) : "".concat(state === null || state === void 0 ? void 0 : state.totalSelected, " items selected");
      default:
        return '';
    }
  }
  return /*#__PURE__*/React__default.createElement(TableBatchActions, {
    shouldShowBatchActions: !!props.selectedRows.length,
    onCancel: function onCancel() {
      props.onClose();
    },
    totalSelected: props.selectedRows.length,
    translateWithId: renderTranslateWithId
  }, _renderItems());
}

export { IlDataTableV3Toolbar as default };
